import React from 'react'
import maybank from './img/maybank.png';
import config from '../appconfig/config.json';
import storage from '../factory/StorageFactory';
 

export const Header = (props) => {
    const handleClose = (e) => {
        e.preventDefault();
        window.location.href = config.link.Cancle;
        storage.clearAll();
    }
    return (
        <div className='container-fluid header-background'>
            <div className="d-flex border-bottom py-2">
                <div className="d-flex ">
                    <div className='project-name d-flex'  >
                        <span className="mx-0 my-auto logo">
                        <img className='imgHeader' src={maybank} alt='maybank' />
                        </span>
                    </div>
                   
                </div>
                <div className='d-flex ml-auto nav'>
                <button  className="closeonheader" onClick={handleClose}>close  X</button>
                    {/* <MenuNavContainer /> */}
                </div>
            </div>
        </div>
    )
}